import * as React from 'react';
import { withNodeResizable } from '../shared/NodeResizable';
import { Portal } from '../shared/Portal';
import { createEmbedExtension } from '../shared/createEmbedExtension';
import { EmbedRendererProps } from '../shared/types';

const URL_REGEX =
  /(http|https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|)(\d+)(?:\/|\?)?([\d\w]+)?/;
export const ENABLED = [URL_REGEX];

export const Component = ({ url, ...rest }: EmbedRendererProps<any>) => {
  const newUrl = React.useMemo(() => {
    const matches = URL_REGEX.exec(url);
    const videoId = matches ? matches[4] : '';
    const hId = matches ? matches[5] : '';
    const embedUrl = `https://player.vimeo.com/video/${videoId}?byline=0${hId ? `&h=${hId}` : ''}`;
    return embedUrl;
  }, [url]);

  return (
    <Portal
      {...rest}
      url={newUrl}
      title="Vimeo Embed"
      fullHeight
      withMetadata
    />
  );
};

export default createEmbedExtension({
  regexp: [URL_REGEX],
  name: 'vimeo-embed',
  component: withNodeResizable(Component, {
    lockAspectRatio: true,
  }),
  addCommandOption: {
    title: 'Vimeo',
    description: 'Embed a Vimeo video.',
    searchTerms: ['embed', 'vimeo'],
    icon: 'logos:vimeo',
  },
});
